<template>
  <div class="l-container">
    <LazyUiDisclaimerList
      v-if="pageData?.selectedCategory && pageData?.selectedCategory.id"
      :key="pageData?.selectedCategory.id"
      :category="pageData?.selectedCategory"
    />
    <slot name="listings-top" />
    <DelayHydration>
      <div class="products-list" :class="`${typeDisplay}-view`">
        <ListingsFilters
          v-model:position="positionFiltersSubmit"
          :values="filtersVal"
          :filters="filters"
          :products="productsCount"
          :count="filtersCount"
          :discount-max="discountMax"
          :loading="filtersCountLoading"
          :curtain-open="curtainOpen"
          :choosed="atLeastOne"
          :is-change-shops="isChangeShops"
          :is-mobile="isMobile"
          :is-changed="isChanged"
          :where-str="whereStr"
          :brand-query="brandQuery"
          :shop-query="shopQuery"
          :go-to-slug="goToSlug"
          :filters-get-query="filtersGet"
          @update:brand-query="(v: string) => (brandQuery = v)"
          @update:shop-query="(v: string) => (shopQuery = v)"
          @get-with-new="getWithNewFilters"
          @filters-change="filtersChange"
          @change-filters-query="changeFiltersQuery"
          @close="curtainOpen = false"
          @cancel-active="cancelActiveFilter"
          @clear-active="(e: boolean) => clearFilters(e)"
        >
          <template #before-price>
            <FiltersCategoryFilter
              v-if="dataFilterBrand"
              class="filter-category"
              :categories="pageData.categories"
              :without-slug-query="`&brand_id=${data.brand_id}&query=${data.h1}`"
              links
            />
            <FiltersCategoryFilter
              v-if="dataFilterShop"
              class="filter-category"
              :categories="pageData.categories"
              :active="pageData.selectedCategory"
              @change="categoryChange"
            />
            <slot name="before-price" />
          </template>
          <template #after-filters>
            <slot name="after-filters" />
          </template>
        </ListingsFilters>
        <div class="products-wrapper">
          <div
            class="controls sticky-container-top-filter"
            :class="{
              'sticky-container-top-filter--not-sticky': sortOpen,
            }"
          >
            <UiPSelect
              class="sort-select"
              font-class="body-l-regular"
              :list="sort.list"
              :value="sort.value"
              value-param="value"
              select-style="text"
              :list-width="232"
              placeholder="Сортировка"
              @open="sortOpen = true"
              @close="sortOpen = false"
              @change="changeSort"
            />
            <ui-preload-images :images-preload="imagesPreload">
              <UiToggleVisibilityListImg
                :images="imagesPreload"
                class="toggle-visibility-list"
                :type-display="typeDisplay"
                :is-mobile="isMobile"
                @toggle-type-display="toggleTypeDisplay"
              />
            </ui-preload-images>
            <ListingsFiltersButton
              :count="filtersButtonCount"
              :visible="curtainOpen"
              @click="curtainOpen = true"
            />
          </div>
          <FiltersActiveFilters
            v-if="!isMobile"
            :list="filtersVal.active || []"
            @cancel="cancelActiveFilter"
            @clear-all="clearActiveFilters"
            @change-data="(e) => $emit('change-data', e)"
          />

          <BlogArticlesImport
            v-if="blogArticlesListing.items?.length"
            :key="`blog-article_${blogArticlesListing.items?.length}`"
            :articles="blogArticlesListing"
            type="model"
            class="content-block"
            view="inListing"
          />
          <div
            v-if="resultListMixer?.length"
            ref="productsList"
            class="products-wrap products-list"
            :class="[typeDisplay, { 'm-button': typeDisplay === 'tile' }]"
          >
            <ProductCardGlobalCardsMixer
              v-for="(product, index) in resultListMixer"
              :key="`${index}-global-cards-mixer`"
              :model="product"
              :type="product.type"
              :discount-max="getDiscountMax(product)"
              :shop-rating-high-count="getShopRatingHighCount(product)"
              :type-display="typeDisplay"
              :type-style="typeDisplay"
              :offers="product?.id ? productsOffers[product.id] : []"
              :lazy-img="!isBot && !loadedImages[product?.id]"
              :is-bot="isBot"
              :show-more-button="true"
              :index="index"
              :add-filter-query="filtersQueryNoSort"
              :position="itemsOffset + index"
              :current-category="pageData.selectedCategory?.id || null"
              block-type="listing"
              use-schema
            />
          </div>
          <object
            v-show="loading"
            class="loading-products"
            data="/static/images/loader-button-invert.svg"
            type="image/svg+xml"
          >
            <img src="/static/images/loader-button-invert.svg" alt />
          </object>
          <div v-if="pageCount > 1 && !loading" class="paginations">
            <ui-ui-button
              :font-weight="400"
              type="neutral"
              class="get-more-data-button"
              size="large"
              :disabled="pageCount === pageActive"
              @click="getMoreData"
            >
              Показать еще
            </ui-ui-button>
            <div class="pagination-wrap">
              <LazyUiPagination
                :page-count="pageCount"
                :active="pageActive"
                links
                @on-page-change="changePage"
              />
            </div>
          </div>
          <ui-empty-state
            v-if="dataEmptyState && !loading"
            image="/static/images/sad-smiley.svg"
          >
            <template #title>
              К сожалению, по данному набору
              <br class="br-desktop" />
              параметров ничего не нашлось
            </template>
            Попробуйте выбрать другие фильтры или воспользуйтесь поиском
          </ui-empty-state>
          <slot name="before-seo" />
          <div
            v-if="seoTextShow && !hideSeoText && seoText"
            class="seo-text-wrap"
          >
            <RenderHTML
              :seotext="seoText"
              class-wrapper="block-text-description"
            />
          </div>
          <slot name="after-products" />
        </div>
      </div>
    </DelayHydration>
    <client-only>
      <LazyModalsAdultModal v-if="adult" @confirm="onAdultConfirm" />
    </client-only>
  </div>
</template>

<script setup lang="ts">
import { useDebounceFn } from '@vueuse/core';
import type {
  DynamicPageContext,
  ModelItem,
  ResponseCategoryFilters,
  ResponseModelOffers,
} from '~/interfaces/api';
import { listingsPageBlocks, sortListings } from '~/common/const';
import { useListingsLazy } from '~/composition/useListingsLazy';
import { useFilters } from '~/composition/useFilters';
import { useGlobalStore } from '~/stores/global';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useAnalyticsStore } from '~/stores/analytics';
import { getAnyPostData, getAnyPostDataDebug } from '~/api/pageCategoryList';
import type {
  ActiveFilter,
  PostBodyFilters,
  SelectedCategoryInfo,
  TargetHTMLAnchorElement,
} from '~/interfaces/app';
import { mergeFilters } from '~/utils/mergeFilters.js';
import { getArticlesByCategory } from '~/api/global';
import RenderHTML from '~/components/ui/RenderHTML.vue';

const BlogArticlesImport = defineAsyncComponent(
  () => import('~/components/blog-articles/BlogArticles.vue')
);
const { $ymClickSortEvent } = useNuxtApp();

const props = defineProps({
  data: {
    type: Object as () => DynamicPageContext,
    required: true,
  },
  count: {
    type: [Number, String],
    default: 0,
  },
  typePage: {
    type: String,
    default: '',
  },
  pageData: {
    type: Object as any,
    required: true,
  },
  filtersUrl: {
    type: String,
    required: true,
  },
  productsUrl: {
    type: String,
    required: true,
  },
  seoTextShow: Boolean,
  canChangeCategory: Boolean,
  constProductsParams: {
    type: Object,
    default: () => {},
  },
  whereStr: String,
  discount: Boolean,
  showMoreButton: {
    type: Boolean,
    default: true,
  },
  sortMarket: {
    type: Array,
    default: () => [],
  },
});
const type3pages = [
  'category-list',
  'category-brand',
  'category-preset',
  'category-discount',
];
const emit = defineEmits(['change-data', 'update:count']);
const globalStore = useGlobalStore();
const mediaStore = useMediaQueryStore();
const analyticsStore = useAnalyticsStore();
const route = useRoute();
const router = useRouter();
const loading = ref<boolean>(false);
const isChangeShops = ref<boolean>(false);
const isBot = computed(() => globalStore.isBot);
const isSm = computed(() => mediaStore.isSm);
const isMd = computed(() => mediaStore.isMd);
const isLg = computed(() => mediaStore.isLg);
const isXl = computed(() => mediaStore.isXl);
const isXXl = computed(() => mediaStore.isXXl);
const isMobile = computed(
  () => mediaStore.isMd || mediaStore.isSm || mediaStore.isEs
);

const sort = ref({
  value: String(route.query['products-sort'] || sortListings[0].value),
  list: props.sortMarket.length > 0 ? props.sortMarket : sortListings,
});
const maxHeight = ref('initial');
const lastActiveFilters = ref<ActiveFilter[]>([]);
const dataFilterShop = computed(() => {
  return (
    props.typePage === 'shop' &&
    props.pageData?.categories &&
    props.pageData?.categories?.length
  );
});
const dataFilterBrand = computed(() => {
  return (
    props.typePage === 'brand' &&
    props.pageData?.categories &&
    props.pageData?.categories?.length
  );
});
const component = globalStore?.seoData?.page?.component;
const dataEmptyState = ref<Boolean>(
  !props.pageData?.products || !props.pageData?.products?.length
);

watch(
  () => props.pageData?.products,
  () => {
    setTimeout(() => {
      dataEmptyState.value =
        !props.pageData?.products || !props.pageData?.products?.length;
    }, 10);
  }
);

// page_blocks - количество блоков подгружаемых при скролле на 1 странице, так же изменить в distributor
const per_page = globalStore.perPageListingValue;
const page_blocks = listingsPageBlocks;

const emptyProducts = Array(per_page).fill({});
const pageCount = ref<number>(
  props.pageData?.total
    ? Math.ceil(props.pageData?.total / (page_blocks * per_page))
    : 1
);

const pageActive = ref<number>(route.query?.page ? +route.query?.page : 1);
const brandQuery = ref<string>('');
const shopQuery = ref<string>('');

const itemsOffset = computed(() => {
  return (pageActive.value - 1) * page_blocks * per_page + 1;
});

const adult = computed(() => globalStore.isOpenAdultModal);

const getTypeDisplay = () => {
  if (route.query && 'type-display' in route.query) {
    const type = route.query['type-display'];
    if (type === 'tile' || type === 'list') {
      return type;
    }
  }
  return props.pageData?.selectedCategory?.default_layout || 'tile';
};

const typeDisplay = ref<string>(getTypeDisplay());

const hideSeoText = ref<boolean>(pageActive.value > 1);

// лейзи лоадинг
const productsList = ref<HTMLElement>();
const {
  beforePageChangeLazy,
  newObserve,
  productsOffers,
  loadedImages,
  intersectPage,
} = useListingsLazy(
  getProducts,
  isBot.value,
  page_blocks,
  per_page,
  isMobile,
  productsList
);

watch(
  () => isMobile.value,
  (_, old) => {
    if (old && typeDisplay.value === 'list')
      nextTick(() => newObserve('[data-id]'));
  }
);

// фильтры
const filters = ref<ResponseCategoryFilters>(props.pageData?.filters || {});
const saveFilters = ref(props.pageData?.filters);
const curtainOpen = ref<boolean>(false);
const sortOpen = ref<boolean>(false);
const positionFiltersSubmit = ref<{ top: string; left: string } | null>(null);
const productsCount = ref<number>(props.pageData?.total || 0);
const filtersGet = ref({
  price: '',
  id: 0,
  count: 0,
  brands: [],
  filters: [],
});
const filtersCount = ref<number>(
  filtersGet.value.count || Number(props.count) || 0
);
const discountMax = ref<number>(Number(props?.pageData?.discount_max) || 0);
const goToSlug = ref<string>('');

const filtersCountLoading = ref<boolean>(false);
const {
  formatFiltersForRequest,
  initiateFilters,
  cancelActiveFilter,
  clearFilters,
  filtersChange,
  atLeastOne,
  getWithNewFilters,
  getFiltersForRequest,
  values: filtersVal,
  isChanged,
  resetValues,
  filtersQuery,
  changeFiltersQuery,
} = useFilters(
  filters.value,
  getCount,
  getProducts,
  true,
  globalStore.debugPanel
);
const filtersButtonCount = computed<number>(
  () => filtersVal.value.active?.length || 0
);
const filtersQueryNoSort = computed(() => {
  if (filtersQuery.value && filtersQuery.value.includes('products-sort')) {
    const params = new URLSearchParams(filtersQuery.value);
    params.delete('products-sort');
    return params.toString();
  }
  return filtersQuery.value;
});

async function getFilters(): Promise<any> {
  const params = {
    region_id: globalStore.region?.id,
    category_id: props.canChangeCategory
      ? props.pageData?.selectedCategory?.id
      : undefined,
    sem: globalStore.sem || undefined,
    adult: globalStore.adult,
    device: globalStore.device || undefined,
    split: analyticsStore.additional?.split,
  };
  const filtersData = await getAnyPostData(props.filtersUrl, null, {
    params,
  });
  if (filtersData) {
    emit('change-data', {
      key: 'filters',
      data: filtersData ? { filters: [], ...filtersData } : null,
    });
  } else {
    emit('change-data', {
      key: 'filters',
      data: { filters: [] },
    });
  }
  return filtersData;
}

function isResponseChanged(oldData: any, newData: any): boolean {
  return JSON.stringify(oldData) !== JSON.stringify(newData);
}

function updateIsChangeShops(oldData: any, newData: any) {
  isChangeShops.value = isResponseChanged(oldData, newData);
}

async function getCount() {
  const params = {
    region_id: globalStore.region?.id,
    category_id: props.canChangeCategory
      ? props.pageData?.selectedCategory?.id
      : undefined,
    sem: globalStore.sem || undefined,
    adult: globalStore.adult,
    device: globalStore.device || undefined,
    split: analyticsStore.additional?.split,
    shop_ids: route?.query?.shop_ids,
    ...props.constProductsParams,
  };
  filtersCountLoading.value = true;
  const reqBody = formatFiltersForRequest();
  if (props.discount) reqBody.discount = 1;
  const contData = await getAnyPostData<any>(props.filtersUrl, reqBody, {
    params,
  });

  updateIsChangeShops(filtersGet.value, contData);

  filtersCount.value = contData?.count || 0;
  filtersGet.value = contData;
  goToSlug.value = contData?.slug;
  filtersCountLoading.value = false;
}

async function getProducts(
  loadFirst = false,
  newFilters = false,
  num = 1,
  getMoreItems = false
): Promise<any> {
  loading.value = true;
  if (loadFirst) beforePageChange(1);
  const params = {
    ...props.constProductsParams,
    region_id: globalStore.region?.id,
    category_id: props.canChangeCategory
      ? props.pageData?.selectedCategory?.id
      : undefined,
    sort: sort.value.value,
    page: isBot.value
      ? pageActive.value
      : getMoreItems
      ? pageActive.value
      : (pageActive.value - 1) * page_blocks + num,
    per_page: isBot.value ? per_page * page_blocks : per_page,
    sem: globalStore.sem || undefined,
    adult: globalStore.adult,
    device: globalStore.device || undefined,
    split: analyticsStore.additional?.split,
    shop_ids: route.query?.shop_ids,
  };
  positionFiltersSubmit.value = null;
  const reqBody = getFiltersForRequest(newFilters);
  if (props.discount) reqBody.discount = 1;
  const isDebugData = type3pages.includes(component);
  const productsData = isDebugData
    ? await getAnyPostDataDebug<any>(props.productsUrl, reqBody, {
        params,
        progress: num < 2,
      })
    : await getAnyPostData<any>(props.productsUrl, reqBody, {
        params,
        progress: num < 2,
      });
  if (productsData) {
    emit('change-data', {
      key: 'products',
      data:
        num === 1
          ? productsData.list
          : props.pageData?.products.concat(productsData.list),
    });
    intersectPage[num - 1] = false;
    pageCount.value = Math.ceil(
      productsData.total / (productsData.per_page * page_blocks)
    );
    nextTick(() => newObserve());
  } else if (num === 1) {
    emit('change-data', {
      key: 'products',
      data:
        props.pageData?.products &&
        props.pageData?.products.length > 0 &&
        props.pageData?.products[0]?.id
          ? props.pageData?.products
          : null,
    });
  }
  productsCount.value = productsData?.total;
  emit('update:count', productsCount.value);
  emit('change-data', {
    key: 'count',
    data: productsCount.value,
  });
  hideSeoText.value = pageActive.value > 1;

  // срабатывать только в листингах из задачи
  if (props.filtersUrl?.includes('categories')) {
    await getActiveFilters(reqBody, params);
  }

  setTimeout(() => {
    loading.value = false;
  }, 100);
}

const getMoreData = () => {
  if (pageActive.value >= pageCount.value) return;
  pageActive.value++;
  getProducts(false, false, 0, true);
  router.push({
    query: {
      ...route.query,
      page: pageActive.value,
    },
  });
};

async function getActiveFilters(
  reqBody: PostBodyFilters,
  params: { [key: string]: TargetHTMLAnchorElement }
) {
  if (!filtersVal.value.active || filtersVal.value.active.length === 0) {
    lastActiveFilters.value = [];
    filters.value = saveFilters.value;
    emit('change-data', {
      key: 'filters',
      data: saveFilters.value,
    });
    setTimeout(() => {
      initiateFilters(false, saveFilters.value);
    });
    return;
  }
  const activeFiltersData = await getAnyPostData<any>(
    props.filtersUrl,
    reqBody,
    {
      params: { ...params, check_offers: true },
    }
  );
  const formatedLastFilters = lastActiveFilters.value.map(
    (i) => `${i.filter}_${i.id}_${i?.item_id || ''}`
  );
  const formatedCurrentFilters = filtersVal.value.active.map(
    (i) => `${i.filter}_${i.id}_${i?.item_id || ''}`
  );
  // список последних установленных фильтров
  const addedFilters = filtersVal.value.active.filter((i) => {
    const item = `${i.filter}_${i.id}_${i?.item_id || ''}`;
    return !formatedLastFilters.includes(item);
  });
  const removedFilters = lastActiveFilters.value.filter((i) => {
    const item = `${i.filter}_${i.id}_${i?.item_id || ''}`;
    return !formatedCurrentFilters.includes(item);
  });

  lastActiveFilters.value = filtersVal.value.active;
  const mergeData = mergeFilters(
    saveFilters.value,
    activeFiltersData,
    [...addedFilters, ...removedFilters],
    filtersVal.value.active
  );
  filters.value = mergeData;
  emit('change-data', {
    key: 'filters',
    data: mergeData,
  });
  setTimeout(() => {
    initiateFilters(false, mergeData);
  });
}

async function initiateDate(
  loadFirst = false,
  withClear = false
): Promise<any> {
  if (withClear) {
    emit('change-data', {
      key: 'products',
      data: [],
    });
    emit('change-data', {
      key: 'filters',
      data: null,
    });
    sort.value.value = sortListings[0].value;
    resetValues();
  }
  await Promise.all([
    getFilters().then((data) => initiateFilters(false, data)),
    getProducts(loadFirst, true),
  ]);
}

function changeSort(val: string): void {
  sort.value.value = val;
  $ymClickSortEvent(val);
  if (router)
    router.replace({
      path: route.path,
      query: {
        ...route.query,
        'products-sort': sort.value.value,
        page: undefined,
      },
    });

  getProducts(true);
}

function changePage(page: number): void {
  beforePageChange(page);
  const newPage =
    pageActive.value === 1 ? undefined : pageActive.value.toString();
  if (router && route.query.page !== newPage) {
    router.replace({
      path: route.path,
      query: { ...route.query, page: newPage },
    });
    setTimeout(() => {
      getProducts();
    });
  }
}

function toggleTypeDisplay(value: string): void {
  const getTypeDisplay = (type: string) => {
    if (type === 'list') return 'tile';
    if (type === 'tile') return 'list';
    return 'list';
  };
  const setValue = isMobile.value ? getTypeDisplay(value) : value;
  if (router)
    router.replace({
      path: route.path,
      query: { ...route.query, 'type-display': setValue },
    });
  typeDisplay.value = setValue;
  resultListMixer.value = setMixing(
    props.pageData?.products,
    numberOfCards.value
  );
  // отдаем контейнеры для пересечения для подгрузки новой порции моделей
  // для листинга с data-id, для тайлов без
  getMaxHeight();
  nextTick(() => newObserve());
}

function beforePageChange(page: number): void {
  pageActive.value = page;
  emit('change-data', {
    key: 'products',
    data: props.pageData?.products?.length ? [] : null,
  });
  beforePageChangeLazy();
  window.scrollTo({
    top: 0,
    left: 0,
  });
}

function onAdultConfirm() {
  emit('change-data', {
    key: 'products',
    data: emptyProducts,
  });
  getProducts();
  globalStore.setOpenAdultModal(false);
}

function categoryChange(category: SelectedCategoryInfo) {
  if (
    props.canChangeCategory &&
    props.pageData?.selectedCategory?.id !== category?.id
  ) {
    emit('change-data', {
      key: 'selectedCategory',
      data: category,
    });
    router?.replace({
      path: route.path,
      query: { category_id: category?.id },
    });
    if (props.pageData?.selectedCategory?.adult) {
      globalStore.setOpenAdultModal(true);
    }
    nextTick(() => initiateDate(true, true));
  }
}

if (props.pageData?.selectedCategory?.adult) {
  globalStore.setOpenAdultModal(true);
}

if (isBot.value) {
  initiateFilters();
  getFiltersForRequest(true);
}

const getMaxHeight = () => {
  if (import.meta.env.SSR || typeDisplay.value !== 'tile') return;
  nextTick(() => {
    const arrHeight = new Set<number>();
    const allCards: NodeListOf<HTMLElement> = document.querySelectorAll(
      '.global-card-mixer__tile'
    );
    if (!allCards || allCards.length < 1) return;
    // clear height's card before setting new maxHeight
    for (const elem of allCards) {
      elem.style.height = 'auto';
      elem.style.maxHeight = 'unset';
    }
    // get height from all cards
    for (const elem of allCards) {
      arrHeight.add(elem.offsetHeight);
    }
    if (isBot.value) {
      maxHeight.value = String(
        Array.from(arrHeight).sort((a, b) => b - a)[0] + 20
      );
    } else {
      maxHeight.value = String(Array.from(arrHeight).sort((a, b) => b - a)[0]);
    }

    allCards.forEach((elem, index) => {
      elem.style.maxHeight = maxHeight.value + 'px';
      if (!((index + 1) % numberOfCards.value)) {
        elem.classList.remove('not-last-in-line');
        elem.classList.add('last-in-line');
      } else {
        elem.classList.remove('last-in-line');
        elem.classList.add('not-last-in-line');
      }
    });
  });
};

const onResize = useDebounceFn(() => {
  getMaxHeight();
}, 10);

const clearActiveFilters = () => {
  clearFilters(true);
  brandQuery.value = '';
  shopQuery.value = '';
};
const oldNumberOfCards = ref<number>(2);
const numberOfCards = computed(() => {
  if (isSm.value || isMd.value || isLg.value) {
    return 3;
  }
  if (isXl.value || isXXl.value) {
    return 4;
  }
  return 2;
});
const isBanner = computed(() => {
  const bannersArr: [{ type?: string; position?: number }?] = [];
  bannersArr.push({
    block: {
      id: '0',
    },
    type: 'price-banner',
    position: 2,
  });
  return bannersArr;
});
const insert = (arr: string[], index: number, item: string) => {
  return [...arr.slice(0, index), item, ...arr.slice(index)];
};
const setMixing = (offers: ResponseModelOffers[], numberValue: number) => {
  const carsInRow = typeDisplay.value === 'list' ? 1 : numberValue;
  if (isBot.value || !offers?.length) {
    return offers;
  }
  return isBanner.value
    ? isBanner.value
        .sort((a, b) => a.position - b.position)
        .reduce(
          (sum, el, index) => {
            return insert(sum, carsInRow * el.position + index, el);
          },
          [...offers]
        )
    : offers;
};

const resultListMixer = ref<any>(props?.pageData?.products || []);
const getDiscountMax = (product: ModelItem) => {
  return product?.discount_max || 0;
};
const getShopRatingHighCount = (product: ModelItem) => {
  return product?.shop_rating_high_count &&
    Number(product?.shop_rating_high_count) !== 0
    ? product?.shop_rating_high_count
    : 0;
};

const blogArticlesListing = ref<any>([]);

watch(
  () => props.pageData?.products,
  (n, m) => {
    if (
      (n &&
        m &&
        n[0] &&
        m[0] &&
        n[0]?.id === m[0]?.id &&
        n.length === m.length) ||
      (!m && !n)
    ) {
      return;
    }
    setTimeout(() => {
      resultListMixer.value = setMixing(n, numberOfCards.value);
      getMaxHeight();
    }, 50);
  },
  { immediate: true, deep: true }
);
watch(
  () => numberOfCards,
  (n) => {
    if (oldNumberOfCards.value === n.value) return;
    setTimeout(() => {
      oldNumberOfCards.value = n.value;
      resultListMixer.value = setMixing(props.pageData?.products, n.value);
      getMaxHeight();
    }, 50);
  },
  { immediate: true, deep: true }
);

const seoText = globalStore?.seoData?.page?.text || '';
const checkSeo = () => {
  if (
    seoText &&
    (seoText.includes('offer_count') || seoText.includes('shop_count')) &&
    props.pageData?.updateSeoTextsData
  ) {
    globalStore.updateSeoTexts(props.pageData?.updateSeoTextsData);
  }
};
checkSeo();
const imagesPreload: { url: string }[] = [
  {
    url: '/static/images/icon/list-container.svg',
  },
  {
    url: '/static/images/icon/list-container-active.svg',
  },
  {
    url: '/static/images/icon/tile-container.svg',
  },
  {
    url: '/static/images/icon/tile-container-active.svg',
  },
];

onMounted(async () => {
  oldNumberOfCards.value = numberOfCards.value;
  initiateFilters(false, filters.value);
  const reqFiltersBody = getFiltersForRequest(true);
  if (
    reqFiltersBody?.price ||
    reqFiltersBody?.brand_id ||
    (reqFiltersBody?.filters && reqFiltersBody?.filters.length)
  ) {
    const params = {
      ...props.constProductsParams,
      region_id: globalStore.region?.id,
      category_id: props.canChangeCategory
        ? props.pageData?.selectedCategory?.id
        : undefined,
      sort: sort.value.value,
      page: isBot.value
        ? pageActive.value
        : (pageActive.value - 1) * page_blocks + 1,
      per_page: isBot.value ? per_page * page_blocks : per_page,
      sem: globalStore.sem || undefined,
      adult: globalStore.adult,
      device: globalStore.device || undefined,
      split: analyticsStore.additional?.split,
      shop_ids: route.query?.shop_ids,
    };
    getActiveFilters(reqFiltersBody, params);
  }
  if (props.pageData?.selectedCategory?.adult) {
    globalStore.setOpenAdultModal(true);
  }
  if (!import.meta.env.SSR && window) {
    window.addEventListener('resize', onResize);
  }
  if (props.pageData?.articles) {
    blogArticlesListing.value = props.pageData?.articles;
  } else if (props.pageData?.selectedCategory?.id) {
    const controllerAbortBlog = new AbortController();
    if (!import.meta.env.SSR) {
      globalStore.setCancelToken(controllerAbortBlog);
    }
    const resData = await getArticlesByCategory(
      props.pageData?.selectedCategory?.id,
      {
        signal: controllerAbortBlog.signal,
      }
    );
    if (resData?.items?.length > 0) {
      blogArticlesListing.value = resData;
      emit('change-data', {
        key: 'articles',
        data: resData,
      });
    }
  }
  if (props.pageData?.products?.length > 0) {
    resultListMixer.value = setMixing(
      props.pageData?.products,
      numberOfCards.value
    );
  }
  getMaxHeight();
});

useSeoMeta({
  title: () => {
    const addText =
      pageActive.value > 1 ? ` | Страница ${pageActive.value}` : '';
    return `${globalStore?.seoData?.page?.title || ''}${addText}`;
  },
  ogTitle: () => globalStore?.seoData?.page?.title || '',
  description: () => globalStore?.seoData?.page?.description || '',
  ogDescription: () => globalStore?.seoData?.page?.description || '',
});

if (
  import.meta.env.SSR &&
  !props.pageData?.products?.length &&
  route.query?.page
) {
  // Показывать 404, если изначально на странице нет товаров по причине пагинации, иначе добавлять ноиндекс
  throw showError({ statusCode: 404 });
}

onBeforeUnmount(() => {
  if (!import.meta.env.SSR && window) {
    window.removeEventListener('resize', onResize);
  }
});
watch(
  () => curtainOpen.value,
  (value) => {
    if (value) {
      document.body.classList.add('tablet-overflow-hidden');
    } else {
      document.body.classList.remove('tablet-overflow-hidden');
    }
  }
);
</script>
<style scoped lang="scss" src="./ProductsWithFiltersScss.scss"></style>
